import FeatureFlagClient, {
  SupportedFlagTypes,
  GetValueOptions,
} from '@atlassiansox/feature-flag-web-client';

export type SessionData = {
  isAtlassian: boolean;
  featureFlagClient: Partial<FeatureFlagClient> & {
    getFlagValue<T extends SupportedFlagTypes>(
      flagKey: string,
      defaultValue: T,
      options?: GetValueOptions<T>
    ): T;
  };
  frontbucket_version: string;
  tenantId?: string;
};
